<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';

export default {
  name: 'AvailableSlotsDataProvider',
  props: {
    sponsorId: { type: String, required: true }
  },
  created() {
    this.fetchForSponsor(this.sponsorId);
  },
  watch: {
    sponsorId(newId) {
      if (newId) this.fetchForSponsor(newId);
      else this.clear();
    }
  },
  beforeDestroy() {
    this.clear();
  },
  methods: {
    ...mapActions('AvailableSlots', ['fetchForSponsor']),
    ...mapMutations('AvailableSlots', ['clear'])
  },
  computed: {
    ...mapGetters('AvailableSlots', ['getItems', 'isLoading', 'failed'])
  },
  render() {
    return this.$scopedSlots.default({
      slots: this.getItems,
      loading: this.isLoading,
      failed: this.failed
    });
  }
};
</script>
